import React from 'react';
import {
	TextInput,
	refreshView,
	useTranslate,
	required,
	useNotify,
	useMutation,
} from 'react-admin';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import PropTypes from 'prop-types';
import BaseDialog from '../../components/dialog/BaseDialog';

const UpdatePaymentInstrument = ({ record, version, method, dataProviderAction, disabled, icon }) => {
	const dispatch = useDispatch();
	const translate = useTranslate();
	const notify = useNotify();
	const [updatePaymentInstrument] = useMutation();

	const handleSubmit = (values, hideDialog) => {
		updatePaymentInstrument({
			type: dataProviderAction,
			resource: 'paymentInstruments',
			payload: {
				id: record.id,
				data: values,
				method,
			},
		},
		{
			onSuccess: () => {
				notify(`resources.paymentInstruments.notifications.update.${method}`, 'info');
				dispatch(refreshView());
				hideDialog();
			},
			onFailure: (error) => {
				notify(error.message, 'error');
			},
		});
	};

	return (
		<BaseDialog
			icon={icon}
			buttonDisabled={disabled}
			buttonLabel={translate(`resources.paymentInstruments.labels.update.${method}.button`)}
			dialogTitle={translate(`resources.paymentInstruments.labels.update.${method}.dialog`)}
			handleSubmit={handleSubmit}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					initialValues={record}
					onSubmit={values => handleSubmit(values, hideDialog)}
					key={version}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<TextInput variant="standard" source="description" validate={required()} fullWidth resettable multiline />
						</form>
					)}
				/>
			)}
		</BaseDialog>
	);
};

UpdatePaymentInstrument.propTypes = {
	record: PropTypes.object.isRequired,
	icon: PropTypes.element.isRequired,
	method: PropTypes.string.isRequired,
	dataProviderAction: PropTypes.string.isRequired,
	disabled: PropTypes.bool.isRequired
};

export default UpdatePaymentInstrument;
